module.exports = __webpack_public_path__ + "static/media/ic_send.7e5716ec.svg";